export default "__VITE_ASSET__CZvF871i__"